import { useState, useRef, useEffect } from "react";

const MobileCountryDropdown = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder,
  searchValue,
  onSearchChange,
  isOpen,
  setIsOpen
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setIsOpen]);

  const handleSelect = (country) => {
    onChange(country.alpha3code || country.id);
    onSearchChange(country.name);
    setIsOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange("");
    onSearchChange("");
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <div className="relative">
        <input
          type="text"
          className="w-full px-2 py-2 pr-7 border border-[#D2D4D8] rounded-lg text-xs bg-white placeholder:text-[#1E1E1ECC] text-[#1E1E1ECC] focus:outline-none focus:ring-1 focus:ring-blue-500"
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => {
            onSearchChange(e.target.value);
            setIsOpen(true);
          }}
          onClick={() => setIsOpen(true)}
        />
        {value && (
          <button
            type="button"
            className="absolute right-7 top-1/2 -translate-y-1/2 p-1"
            onClick={handleClear}
          >
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="#1E1E1ECC"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
        <svg
          className="w-3 h-3 text-[#1E1E1ECC] absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-[#D2D4D8] rounded-lg shadow-lg max-h-60 overflow-auto">
          {options.length > 0 ? (
            options.map((country) => (
              <button
                key={country.id}
                type="button"
                className="w-full px-3 py-2 text-left text-xs hover:bg-gray-50 flex items-center gap-2"
                onClick={() => handleSelect(country)}
              >
                {country.image_url && (
                  <img
                    src={country.image_url}
                    alt={country.name}
                    className="w-4 h-3 object-cover"
                  />
                )}
                <span className="text-[#1E1E1ECC]">{country.name}</span>
              </button>
            ))
          ) : (
            <div className="px-3 py-2 text-xs text-gray-500">
              No countries found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileCountryDropdown;
